import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { Avatar } from 'primereact/avatar';
import { getUserFullName, getUserAvatarColour, parseUserRole, authIsEnabled } from '../../utils/auth';
import { TieredMenu } from 'primereact/tieredmenu';
import { type MenuItem } from 'primereact/menuitem';
import { useAuth } from 'oidc-react';

export default function UserMenu() {
  const auth = authIsEnabled() ? useAuth() : null;
  const { user, role } = useSelector((state: RootState) => state.auth);

  const fullName = getUserFullName(user);

  const initials = fullName
    .split(' ')
    .map((name) => name.charAt(0).toUpperCase())
    .join('');

  const userMenu = React.useRef<TieredMenu>(null);
  const menuItems: MenuItem[] = [
    {
      label: 'Log Out',
      icon: "pi pi-sign-out",
      command: () => auth.signOutRedirect(),
    },
    
  ];

  function toggleUserMenu(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    userMenu.current?.toggle(e);
  }

  return (
    <div className="flex items-center gap-2 cursor-pointer" onClick={toggleUserMenu}>
      <Avatar style={{ backgroundColor: getUserAvatarColour(user) }} label={initials || 'U'} />
      <div>
          <div className="flex items-center justify-between gap-2">
            <span>{fullName}</span>
            <span className="text-xs pi pi-chevron-down text-allstate-navy"></span>
          </div>
          <div className="text-sm text-grey-7">{parseUserRole(role)}</div>
      </div>

      <TieredMenu ref={userMenu} model={menuItems} popup />
    </div>
  )
}